// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwPanel from 'viewmodel/AwPanelViewModel';
import AwPanelBody from 'viewmodel/AwPanelBodyViewModel';
import AwList from 'viewmodel/AwListViewModel';
import AwImageCell from 'viewmodel/AwImageCellViewModel';
import DesCompactImageCell from 'viewmodel/DesCompactImageCellViewModel';
import DesCatalogCustomCell from 'viewmodel/DesCatalogCustomCellViewModel';
import AwDefaultCell from 'viewmodel/AwDefaultCellViewModel';
import AwLabel from 'viewmodel/AwLabelViewModel';
    import { ExistWhen } from 'js/hocCollection';
const DivExistWhen = ExistWhen('div');
DivExistWhen.displayName = 'DivExistWhen';

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/DesCatalogImagesViewService', () => import('js/DesCatalogImagesViewService'));
registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/desCatalogEventBus', () => import('js/desCatalogEventBus'));
registerDynImportEntry('js/desSearchService', () => import('js/desSearchService'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "lifecycleHooks": {
        "onMount": "subscribeRefreshCatalogList",
        "onUpdate": [
            {
                "action": "setFirstCatalogSelection",
                "observers": [
                    "viewModel.dataProviders.catalogImages.viewModelCollection.loadedVMObjects"
                ]
            }
        ],
        "onUnmount": "disconnectIntersectionObserver"
    },
    "data": {
        "overFlow": 0,
        "next": 0,
        "limit": 50,
        "totalCatalogCount": 0,
        "showCatalogList": false,
        "showCatalogPartsList": false,
        "showProviderLabel": true,
        "label": "Catalogs",
        "selectedCatalog": "",
        "displayConstants": {
            "REGULAR": "regular",
            "COMPACT": "compact",
            "CUSTOM": "custom",
            "LIST": "list"
        },
        "noCatalogFound": {
            "displayName": "Label",
            "dbValue": "",
            "type": "STRING",
            "dispValue": "{{i18n.noCatalogFound}}",
            "labelPosition": "NO_PROPERTY_LABEL"
        },
        "resetAttributes": true
    },
    "dataProviders": {
        "catalogImages": {
            "action": "getCatalogsImpl",
            "response": "{{data.libraries}}",
            "totalFound": "{{data.totalFound}}"
        }
    },
    "actions": {
        "setFirstCatalogSelection": {
            "actionType": "JSFunction",
            "method": "setFirstCatalogSelection",
            "inputData": {
                "autoSelectFirst": "{{props.autoSelectFirst}}",
                "data": "{{data}}"
            },
            "deps": "js/DesCatalogImagesViewService"
        },
        "reveal": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "showCatalogImages"
                }
            ]
        },
        "subscribeRefreshCatalogList": {
            "actionType": "JSFunction",
            "method": "subscribeRefreshCatalogList",
            "inputData": {
                "vmo": "{{data}}"
            },
            "deps": "js/DesCatalogImagesViewService"
        },
        "initIntersectionObserver": {
            "actionType": "JSFunction",
            "method": "initIntersectionObserver",
            "inputData": {
                "Imageobjects": "{{data.libraries}}",
                "provider": "{{props.provider}}",
                "acc": "des-catalog-images-view",
                "vmo": "{{data}}",
                "display": "{{props.display}}"
            },
            "deps": "js/DesCatalogImagesViewService"
        },
        "disconnectIntersectionObserver": {
            "actionType": "JSFunction",
            "method": "disconnectIntersectionObserver",
            "deps": "js/DesCatalogImagesViewService"
        },
        "getProviderLabel": {
            "actionType": "JSFunction",
            "method": "getProviderLabel",
            "inputData": {
                "vmo": "{{data}}",
                "provider": "{{props.provider}}"
            },
            "outputData": {
                "providerLabelToDisplay": "providerLabelToDisplay"
            },
            "deps": "js/DesCatalogImagesViewService"
        },
        "showCatalogImages": {
            "actionType": "dataProvider",
            "method": "catalogImages"
        },
        "getCatalogsImpl": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "provider": "{{props.provider}}",
                            "totalCatalogCount": "{{data.totalCatalogCount}}",
                            "display": "{{props.display}}"
                        },
                        "query": "query GetIndexList ($getIndexListInput: GetIndexListInput) { getIndexList (getIndexListInput: $getIndexListInput) }",
                        "variables": {
                            "getIndexListInput": {
                                "catalogspaceId": "{{props.catalogspaceid}}",
                                "limit": "{{props.limit}}",
                                "locale": "{{props.locale}}",
                                "skip": "{{data.next}}",
                                "overFlow": "{{data.overFlow}}",
                                "filter": "{{props.filterStatus}}"
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accsessionid": "{{props.accsessionid}}"
            },
            "outputData": {
                "libraries": "data.data.getIndexList.navigateResponse.index.contents",
                "totalFound": "data.data.getIndexList.navigateResponse.index.totalFound",
                "hasMore": "data.data.getIndexList.navigateResponse.index.hasMore",
                "downloadEndpoint": "data.data.getIndexList.navigateResponse.downloadEndpoint",
                "skip": "data.data.getIndexList.navigateResponse.index.skip",
                "overFlow": "data.data.getIndexList.navigateResponse.index.overFlow",
                "totalCatalogCount": "data.data.getIndexList.navigateResponse.index.totalCatalogCount"
            },
            "events": {
                "success": [
                    {
                        "name": "getIndexList.success",
                        "eventData": {
                            "skip": "{{skip}}"
                        }
                    },
                    {
                        "name": "catalogNavigationTree.autoSelectFirst"
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "performBatchActionOnCatalogSelection": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "publishToACCEventBus",
                    "inputArgs": {
                        "eventName": "{{parameters.eventName}}",
                        "eventData": "{{parameters.eventData}}"
                    }
                },
                {
                    "action": "getContentPathElements",
                    "inputArgs": {
                        "eventName": "{{parameters.eventName}}",
                        "eventData": "{{parameters.eventData}}"
                    }
                }
            ]
        },
        "publishToACCEventBus": {
            "actionType": "JSFunction",
            "method": "publish",
            "inputData": {
                "eventId": "{{parameters.eventName}}",
                "eventData": "{{parameters.eventData}}"
            },
            "deps": "js/desCatalogEventBus"
        },
        "performBatchAction": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "showCatalogParts",
                    "inputArgs": {
                        "eventName": "{{parameters.eventName}}",
                        "eventData": "{{parameters.eventData}}"
                    }
                },
                {
                    "action": "createCatalogSelectionEvent",
                    "inputArgs": {
                        "eventName": "{{parameters.eventName}}",
                        "eventData": "{{parameters.eventData}}"
                    }
                }
            ]
        },
        "getContentPathElements": {
            "actionType": "JSFunction",
            "method": "getContentPathElements",
            "inputData": {
                "eventData": "{{parameters.eventData}}"
            },
            "deps": "js/desSearchService"
        },
        "showCatalogParts": {
            "actionType": "JSFunction",
            "method": "showCatalogParts",
            "inputData": {
                "vmo": "{{data}}",
                "selectedCatalog": "{{eventData.selectedObjects}}"
            },
            "deps": "js/DesCatalogImagesViewService"
        },
        "createCatalogSelectionEvent": {
            "actionType": "Event",
            "method": "Event",
            "inputData": {
                "events": [
                    {
                        "name": "createCatalogSelectionEvent",
                        "eventData": {
                            "eventName": "createCatalogSelectionEvent",
                            "eventData": [
                                "{{props.provider}}",
                                "{{parameters.eventData[0].cellHeader1 || parameters.eventData[0].cellHeader2 }}"
                            ]
                        }
                    }
                ]
            }
        },
        "setNextValueForPagination": {
            "actionType": "JSFunction",
            "method": "setNextValueForPagination",
            "inputData": {
                "vmo": "{{data}}",
                "skip": "{{parameters.skip}}"
            },
            "deps": "js/DesCatalogImagesViewService"
        },
        "getIndexListSuccessBatchJob": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "setNextValueForPagination"
                },
                {
                    "action": "initIntersectionObserver"
                }
            ]
        }
    },
    "props": {
        "accsessionid": {
            "type": "string"
        },
        "provider": {
            "type": "string"
        },
        "catalogspaceid": {
            "type": "string"
        },
        "limit": {
            "type": "integer"
        },
        "display": {
            "type": "string"
        },
        "locale": {
            "type": "string"
        },
        "filterStatus": {
            "type": "string"
        },
        "autoSelectFirst": {
            "type": "boolean"
        }
    },
    "onEvent": [
        {
            "eventId": "catalogImages.selectionChangeEvent",
            "cacheEventData": true,
            "action": "performBatchActionOnCatalogSelection",
            "inputArgs": {
                "eventName": "desCatalogListSelectionChange",
                "eventData": "{{eventData.selectedObjects}}"
            }
        },
        {
            "eventId": "getIndexList.success",
            "action": "getIndexListSuccessBatchJob",
            "inputArgs": {
                "skip": "{{eventData.skip}}"
            }
        },
        {
            "eventId": "des-refreshCatalogImagesList",
            "action": "showCatalogImages"
        },
        {
            "eventId": "catalogNavigationTree.autoSelectFirst",
            "action": "setFirstCatalogSelection"
        }
    ],
    "conditions": {
        "displayRegularView": {
            "expression": "props.display === data.displayConstants.REGULAR"
        },
        "displayCompactView": {
            "expression": "props.display === data.displayConstants.COMPACT"
        },
        "displayCustomView": {
            "expression": "props.display === data.displayConstants.CUSTOM"
        },
        "displayCatalogsAsList": {
            "expression": "props.display === data.displayConstants.LIST"
        },
        "noCatalogFound": {
            "expression": "data.dataProviders.catalogImages.vmCollectionObj.dataLoaded && data.totalCatalogCount === 0"
        }
    },
    "i18n": {
        "noCatalogFound": [
            "DesCatalogImagesViewMessages"
        ]
    },
    "_viewModelId": "DesCatalogImagesView",
    "_uniqueViewModelId": "DesCatalogImagesView",
    "ctx": {}
};

    /*
    <div exist-when="conditions.displayRegularView"
    class="des-catalog-images-view_cellListWidget des-display-regular des-catalog-images-view_cellListItem"
    style="height: 100%;">
    <aw-panel class="h-12">
        <aw-panel-body>
            <aw-list has-floating-cell-commands="false" dataprovider="dataProviders.catalogImages">
                <aw-image-cell vmo="item"></aw-image-cell>
            </aw-list>
        </aw-panel-body>
    </aw-panel>
</div>

<div exist-when="conditions.displayCompactView"
    class="des-catalog-images-view_cellListWidget des-catalog-images-view_cellListItem" style="height: 100%;">
    <aw-panel class="h-12">
        <aw-panel-body>
            <aw-list has-floating-cell-commands="false" dataprovider="dataProviders.catalogImages">
                <des-compact-image-cell vmo="item"></des-compact-image-cell>
            </aw-list>
        </aw-panel-body>
    </aw-panel>
</div>

<div exist-when="conditions.displayCustomView"
    class="des-catalog-images-view_cellListWidget des-catalog-images-view_cellListItem" style="height: 100%;">
    <aw-panel class="h-12">
        <aw-panel-body>
            <aw-list has-floating-cell-commands="false" dataprovider="dataProviders.catalogImages">
                <des-catalog-custom-cell vmo="item"></des-catalog-custom-cell>
            </aw-list>
        </aw-panel-body>
    </aw-panel>
</div>

<div exist-when="conditions.displayCatalogsAsList"
    class='afx-content-background aw-layout-full des-catalog-images-view_listCell' style="height: 100%;">
    <aw-panel class="h-12">
        <aw-panel-body>
            <aw-list dataprovider="dataProviders.catalogImages">
                <cell>
                    <aw-default-cell vmo="item" />
                </cell>
            </aw-list>
        </aw-panel-body>
        <div exist-when="conditions.noCatalogFound">
            <aw-label prop='data.noCatalogFound'></aw-label>
        </div>
    </aw-panel>
</div>
    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
            <Fragment>
    <DivExistWhen className="des-catalog-images-view_cellListWidget des-display-regular des-catalog-images-view_cellListItem" style={{height: '100%'}} existWhen={AwParseService.instance( "conditions.displayRegularView" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
        <AwPanel  revealAction={actions.reveal}  className="h-12">
            <AwPanelBody>
                <AwList dataprovider={dataProviders.catalogImages} showDropArea={null} hasFloatingCellCommands={false} dndHandler={props.viewModel.dndHandler}>{({item, index})=>{ return <>                    <AwImageCell vmo={AwParseService.instance( "item" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports, item, index } )}>
                    </AwImageCell></> } }
                </AwList>
            </AwPanelBody>
        </AwPanel>
    </DivExistWhen>
    <DivExistWhen className="des-catalog-images-view_cellListWidget des-catalog-images-view_cellListItem" style={{height: '100%'}} existWhen={AwParseService.instance( "conditions.displayCompactView" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
        <AwPanel  revealAction={actions.reveal}  className="h-12">
            <AwPanelBody>
                <AwList dataprovider={dataProviders.catalogImages} showDropArea={null} hasFloatingCellCommands={false} dndHandler={props.viewModel.dndHandler}>{({item, index})=>{ return <>                    <DesCompactImageCell vmo={AwParseService.instance( "item" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports, item, index } )}>
                    </DesCompactImageCell></> } }
                </AwList>
            </AwPanelBody>
        </AwPanel>
    </DivExistWhen>
    <DivExistWhen className="des-catalog-images-view_cellListWidget des-catalog-images-view_cellListItem" style={{height: '100%'}} existWhen={AwParseService.instance( "conditions.displayCustomView" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
        <AwPanel  revealAction={actions.reveal}  className="h-12">
            <AwPanelBody>
                <AwList dataprovider={dataProviders.catalogImages} showDropArea={null} hasFloatingCellCommands={false} dndHandler={props.viewModel.dndHandler}>{({item, index})=>{ return <>                    <DesCatalogCustomCell vmo={AwParseService.instance( "item" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports, item, index } )}>
                    </DesCatalogCustomCell></> } }
                </AwList>
            </AwPanelBody>
        </AwPanel>
    </DivExistWhen>
    <DivExistWhen className="afx-content-background aw-layout-full des-catalog-images-view_listCell" style={{height: '100%'}} existWhen={AwParseService.instance( "conditions.displayCatalogsAsList" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
        <AwPanel  revealAction={actions.reveal}  className="h-12">
            <AwPanelBody>
                <AwList dataprovider={dataProviders.catalogImages} showDropArea={null} dndHandler={props.viewModel.dndHandler}>{({item, index})=>{ return <>                    <cell>
                        <AwDefaultCell vmo={AwParseService.instance( "item" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports, item, index } )}>
                        </AwDefaultCell>
                    </cell></> } }
                </AwList>
            </AwPanelBody>
            <DivExistWhen existWhen={AwParseService.instance( "conditions.noCatalogFound" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                <AwLabel {...getField("data.noCatalogFound", fields, $index, null, null )}>
                </AwLabel>
            </DivExistWhen>
        </AwPanel>
    </DivExistWhen>
</Fragment>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;